import { DEFAULT_LANGUAGE } from '@wix/wix-chatbot-common/locale';
import React from 'react';
import { useSelector, useStore } from 'react-redux';

import { WIXEL_CATEGORY } from '../../../constants';
import { renderModel } from '../../util/renderModel';
import { CategoryItemType, getCategories } from '../api/getCategories';
import { useHttpClient } from '../providers/httpClient';
import { helpCenterSlice } from '../reducers/helpCenter';
import { selectCategories, selectCurrentCategory, selectNormalizedCategories } from '../selectors/helpCenter';

export const useCategories = () => {
  const httpClient = useHttpClient();
  const categories = useSelector(selectCategories);
  const currentCategory = useSelector(selectCurrentCategory);
  const normalizedCategories = useSelector(selectNormalizedCategories);
  const store = useStore();
  const locale = renderModel.getLocale();

  const filteredCategories = React.useMemo(() => {
    return [WIXEL_CATEGORY];
  }, []);

  const filterCategories = React.useCallback(
    (allCategories: CategoryItemType[]) => {
      return allCategories.filter((category) => !filteredCategories.includes(category.id));
    },
    [filteredCategories],
  );

  React.useEffect(() => {
    if (!categories?.length) {
      getCategories(locale, httpClient).then((newCategories) => {
        if (newCategories?.length) {
          store.dispatch(helpCenterSlice.actions.setCategories(filterCategories(newCategories)));
        } else {
          getCategories(DEFAULT_LANGUAGE, httpClient).then((_newCategories) => {
            store.dispatch(helpCenterSlice.actions.setCategories(filterCategories(_newCategories)));
          });
        }
      });
    }
  }, [categories?.length, filterCategories, httpClient, locale, store]);

  return { categories, normalizedCategories, currentCategory };
};
